import React, { useState, useEffect } from "react";
import { Layout, Menu, Card } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose1 from "../../Assets/yoga/pose1.jpg";
import { API_BASE_URL } from "../../Config";
import axios from "axios";
import "./CommonResponsive.css";
import AdvertisementCard from "../AdvertisementCard";
const { Sider, Content } = Layout;

const VariationMain = () => {
  const [selectedKey, setSelectedKey] = useState("home");
  const [allYogaPages, setAllYogaPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchAllYoga = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allpages?page=yoga`);
        const json = await res.data;
        setAllYogaPages(json?.data || []);
      } catch (error) {
        console.error("API Fetch Error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllYoga();
  }, []);

  const getDynamicPageContent = (key) => {
    if (key === "home") {
      const home = allYogaPages.find((p) => p.yogaType === "Yoga Main Page");

      if (home) return home.content;

      return `
  <h2 style="text-align:center; margin-bottom:10px; font-size:28px;">What is Yoga?</h2>

  <p style="text-align:center; font-size:16px; max-width:700px; margin:0 auto 30px;">
    Yoga means "union" - the union of body, mind and soul. It is a 5,000-year-old Indian tradition.
  </p>

  <div className="inner_content" 
  style="
      border:1px solid #e6e6e6;
      padding:25px 30px;
      border-radius:12px;
      background:#fff;
      max-width:900px;
      margin:0 auto 40px;
    "
  >

    <h3 style="color:green; font-weight:bold;">The main types of yoga are:</h3>

    <ol style="line-height:1.8; font-size:16px; margin-top:15px;">
      <li>
        <b>Hatha Yoga</b>
        <p>Yoga through physical exercises</p>
        <p>Asanas + Pranayama</p>
        <p>Suitable for beginners</p>
      </li>

      <li>
        <b>Raja Yoga</b>
        <p>Yoga of mind control</p>
        <p>Attaining samadhi through meditation</p>
      </li>

      <li>
        <b>Karma Yoga</b>
        <p>Yoga through service</p>
        <p>Action without attachment</p>
      </li>

      <li>
        <b>Jnana Yoga</b>
        <p>Yoga through knowledge</p>
        <p>"Who am I?" Research on</p>
      </li>

      <li>
        <b>Bhakti Yoga</b>
        <p>Yoga through devotion</p>
        <p>Complete surrender to God</p>
      </li>
    </ol>

  </div>

  <!-- ---------------- 8 Limbs Section ---------------- -->
  <div style="
      border:1px solid #e6e6e6;
      padding:25px 30px;
      border-radius:12px;
      background:#fff;
      max-width:900px;
      margin:0 auto 40px;
    "
  >
    <h3 style="color:green; font-weight:bold;">The 8 limbs of yoga (Ashtanga Yoga):</h3>

    <ol style="line-height:1.8; font-size:16px; margin-top:15px;">

      <li>
        <b>Yama (5 precepts - external conduct)</b>
        <p>Ahimsa – non-killing</p>
        <p>Truthfulness – non-lying</p>
        <p>Asteyam – non-stealing</p>
        <p>Brahmacharya – restraint of the senses</p>
        <p>Aparigraha – absence of desire</p>
      </li>

      <li>
        <b>Niyama (5 precepts - internal conduct)</b>
        <p>Saucham – cleanliness</p>
        <p>Happiness – mental contentment</p>
        <p>Tapas – hard training</p>
        <p>Svadhyayam – self-knowledge</p>
        <p>Eswara Pranidhanam – surrender to God</p>
      </li>

      <li>
        <b>Asana</b>
        <p>Positions</p>
        <p>Stability and comfort</p>
      </li>

      <li>
        <b>Pranayama</b>
        <p>Breath control</p>
        <p>Management of the life force</p>
      </li>

      <li>
        <b>Pratyakara</b>
        <p>Introspection of the senses</p>
      </li>

      <li>
        <b>Dharana</b>
        <p>Focusing the attention</p>
      </li>

      <li>
        <b>Dhyana</b>
        <p>Continuous flow of attention</p>
      </li>

      <li>
        <b>Samadhi</b>
        <p>The state of complete unity</p>
      </li>

    </ol>
  </div>

  <!-- ---------------- Scientific Benefits ---------------- -->
  <div style="
      border:1px solid #e6e6e6;
      padding:25px 30px;
      border-radius:12px;
      background:#fff;
      max-width:900px;
      margin:0 auto;
    "
  >
    <h3 style="color:green; font-weight:bold;">Scientific Benefits of Yoga:</h3>

    <h4>For the Body:</h4>
    <ul>
      <li>Increased Flexibility</li>
      <li>Increased Muscle Strength</li>
      <li>Strengthened Skeletal System</li>
      <li>Improved Blood Flow</li>
      <li>Improved Immunity</li>
    </ul>

    <h4>For the Mind:</h4>
    <ul>
      <li>Reduced Stress</li>
      <li>Improved Focus</li>
      <li>Emotional Balance</li>
      <li>Improved Sleep</li>
      <li>Increased Mental </li>
      <li>Satisfaction</li>
    </ul>

    <h3 style="color:green; font-weight:bold;">Daily Yoga: (Under the guidance of the teacher)</h3>

<p style="color:red;"><b>Early Morning or Evening: (empty stomach)</b></p>
<ul>
  <li>Shatkarma or cleaning process (Only under guidance)</li>
  <li>Pranayama – 10 Minutes (Oxygen for all organs)</li>
  <li>Warm-up – 10 minutes (Preparing the Body and Mind)</li>
  <li>Asanas – 30–45 Minutes (Bilateral Balance or alternate Exercise)</li>
  <li>Meditation – 10–15 Minutes (Preparing the Mind for Peace)</li>
  <li>Savasana – 10 minutes (Resting the Body)</li>
</ul>

    <h4>Guarantee for Beginners of Yoga:</h4>
    <p style="color:red;"><b>Required Equipment</b></p>
    <ul>
      <li>Yoga Mat</li>
      <li>Comfortable Clothes</li>
      <li>Empty Stomach or 4 hours after eating.</li>
    </ul>

    <h3 style="color:red;">Important notes:</h3>
    <ul>
      <li>In the beginning, teacher guidance is important</li>
      <li>Do according to physical ability</li>
      <li>Do not be competitive</li>
      <li>Focus on breathing</li>
      <li>Savasana is important</li>
    </ul>

    <h3>Key philosophies of yoga:</h3>
    <ul>
      <li>Yoga is the cessation of mind waves</li>
      <li>Sthiram Sugam Asanam</li>
      <li>Asana is stable and comfortable</li>
      <li>Ahimsa Paramo Dharma</li>
      <li>Non-violence is the highest</li>
    </ul>
  </div>
`;
    }

    const page = allYogaPages.find((p) => p._id === key);
    return page?.content || "<p>No content found.</p>";
  };

  const menuItems = [
    ...allYogaPages.map((p) => ({
      key: p._id,
      label: p.yogaType,
    })),
    { key: "home", label: "Back to Main Page" },
  ];

  const selectedContent = (
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: getDynamicPageContent(selectedKey) }}
    />
  );

  const yogaMenu = (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      items={menuItems}
      onClick={(e) => {
        setSelectedKey(e.key);
      }}
      style={{
        background: "transparent",
        color: "#fff",
        fontSize: "1rem",
        textAlign: "center",
      }}
    />
  );

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 10px",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Layout
        className="responsive"
        style={{
          width: "90%",
          maxWidth: "1200px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Sider
          className="sub_slider"
          width={250}
          style={{
            height: "100vh",
            backgroundImage: `url(${pose1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
            }}
          />

          <div
            style={{
              position: "relative",
              zIndex: 2,
              padding: "16px",
              fontWeight: "bold",
              textAlign: "center",
              color: "#fff",
            }}
          >
            Explore Yoga 
          </div>

          <Menu
            theme="white"
            mode="inline"
            style={{
              background: "transparent",
              color: "#ffffffA2",
              fontSize: "1.1rem",
              position: "relative",
              zIndex: 2,
              fontWeight: 500,
              textAlign: "center",
            }}
            itemStyle={{ color: "#fff" }}
            onClick={(e) => setSelectedKey(e.key)}
            selectedKeys={[selectedKey]}
            items={menuItems}
          />
        </Sider>

        <Content className="content_responsive" style={{ padding: "30px" }}>
          {loading ? (
            <h2>Loading...</h2>
          ) : (
            <AnimatePresence mode="wait">
              <motion.div
                key={selectedKey}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <Card
                  className="inner_card"
                  style={{ borderRadius: "12px", padding: "24px" }}
                >
                  {selectedContent}
                </Card>
              </motion.div>
            </AnimatePresence>
          )}
        </Content>
      </Layout>
      <AdvertisementCard />
    </motion.div>
  );
};

export default VariationMain;
